import CurrentUser from "../../model2/user/current-user";


// !!! this is config for current company only

// IS OPEN is now in gd.user.settings.navigation.menuSectionsCollapsed !!!

// this settings is deprecated and not in use for pins open etc etc

export default class UserMenuSettings {

    private configAllCompanies  : any   // object with config for all companies

    public myWork               : any

    public homeCustomViews      : any

    public dashboards           : any
    public pinsItems            : any
    public pinsProjects         : any
    public pinsViews            : any
    public pinsTasks            : any
    public pinsUsers            : any
    public pinsDocuments        : any
    public projectsStarred      : any
    public projectsAll          : any
    public projectsTags         : any
    public projectsViews        : any
    public projectsPortfolios   : any
    public toolsCrm             : any
    public customViews          : any
    public sharedCustomViews    : any
    public companyTools         : any
    public collapsedDepartments : any
    public collapsedSettings    : any
    public myReports            : any

    public projectsColorize     : boolean   = false
    public tagsShowMore         : boolean   = false


    constructor(clientData:any) {
        this.configAllCompanies = clientData.menu

        this.init(clientData);
    }

    init(clientData:any) {

        const initData = _.get(clientData.menu, gd.companyId, {});

        //
        // console.log("menu init data", initData);
        // console.log("menu init data", initData.myWork);

        // MY WORK
        this.myWork             = {
            // menuItems: _.get(initData,'myWork.menuItems', defaultMyWorkMenu), // to be removed and killed
            sortPositions   : _.get(initData,'myWork.sortPositions', []),
        };

        this.homeCustomViews    = {
            isOpen          : _.get(initData,'homeCustomViews.isOpen', true),
            sortPositions   : _.get(initData,'homeCustomViews.sortPositions', []),
        }

        this.dashboards         = {
            isOpen          : _.get(initData,'dashboards.isOpen', true),
            sortPositions   : _.get(initData,'dashboards.sortPositions', []),
        };
        this.pinsItems          = {
            isOpen          : _.get(initData,'pinsItems.isOpen', true),
            sortPositions   : _.get(initData,'pinsItems.sortPositions', []),
        };

        this.pinsProjects       = {
            isOpen          : _.get(initData,'pinsProjects.isOpen', true),
            sortPositions   : _.get(initData,'pinsProjects.sortPositions', []),
        };
        this.pinsViews          = {
            isOpen          : _.get(initData,'pinsViews.isOpen', true),
            sortPositions   : _.get(initData,'pinsViews.sortPositions', []),
        };
        this.pinsTasks          = {
            isOpen          : _.get(initData,'pinsTasks.isOpen', true),
            sortPositions   : _.get(initData,'pinsTasks.sortPositions', []),
        };
        this.pinsUsers          = {
            isOpen          : _.get(initData,'pinsUsers.isOpen', true),
            sortPositions   : _.get(initData,'pinsUsers.sortPositions', []),
        };
        this.pinsDocuments      = {
            isOpen          : _.get(initData,'pinsDocuments.isOpen', true),
            sortPositions   : _.get(initData,'pinsDocuments.sortPositions', []),
        };

        // PROJECTS
        this.projectsColorize   = _.get(initData, 'projectsColorize', false)

        this.projectsStarred    = {
            isOpen          : _.get(initData,'projectsStarred.isOpen', true)
        };
        this.projectsAll        = {
            isOpen          : _.get(initData,'projectsAll.isOpen', true),
            sortedMap       : _.get(initData,'projectsAll.sortedMap', {}) // map - {parentId:[projectId1, projectId2, ...]}
        };

        this.projectsTags       = {
            isOpen          : _.get(initData,'projectsTags.isOpen', true),
            sortPositions   : _.get(initData,'projectsTags.sortPositions', []),
        }

        this.projectsViews      = {
            isOpen          : _.get(initData,'projectsViews.isOpen', true)
        };

        this.projectsPortfolios = {
            isOpen          : _.get(initData,'projectsPortfolios.isOpen', true),
            sortPositions   : _.get(initData,'projectsPortfolios.sortPositions', []),
        };

        // TAGS
        this.tagsShowMore   = _.get(initData, 'tagsShowMore', false)

        // TOOLS
        this.toolsCrm           = {
            isOpen          : _.get(initData,'toolsCrm.isOpen', true),
        };
        this.customViews        = {
            isOpen          : _.get(initData,'customViews.isOpen', true),
            sortPositions   : _.get(initData,'customViews.sortPositions', []),
        };
        this.sharedCustomViews  = {
            isOpen          : _.get(initData,'sharedCustomViews.isOpen', true),
            sortPositions   : _.get(initData,'sharedCustomViews.sortPositions', []),
        };
        this.companyTools       = {
            isOpen          : _.get(initData,'companyTools.isOpen', true)
        };
        this.myReports  = {
            isOpen          : _.get(initData,'myReports.isOpen', true),
            sortPositions   : _.get(initData,'myReports.sortPositions', []),
        };

        // USERS
        this.collapsedDepartments = _.get(initData,'collapsedDepartments', []);

        // SETTINGS
        this.collapsedSettings = _.get(initData,'collapsedSettings', ["customization", "users", "notifications", "my-account", "integrations", "company"])
    }

    toggleSection(sectionName:string, isOpen:boolean) {

        // @ts-ignore
        if (!this[sectionName]) {
            console.error("$kldjd90383 strange case")
            return
        }

        // @ts-ignore
        this[sectionName].isOpen = isOpen;
        this.save();
    }

    save() {
        gd.user.clientData.menu = this.toJson();
        gd.user.saveClientData();
    }

    toJson() {
        const result: JSONObject = {
            myWork              : this.myWork,
            dashboards          : this.dashboards,
            homeCustomViews     : this.homeCustomViews,
            pinsProjects        : this.pinsProjects,

            pinsItems           : this.pinsItems,   // new
            pinsViews           : this.pinsViews,

            projectsStarred     : this.projectsStarred,
            projectsAll         : this.projectsAll,
            projectsTags        : this.projectsTags,
            projectsViews       : this.projectsViews,
            projectsPortfolios  : this.projectsPortfolios,
            projectsColorize    : this.projectsColorize,

            tagsShowMore        : this.tagsShowMore,

            toolsCrm            : this.toolsCrm,
            customViews         : this.customViews,
            sharedCustomViews   : this.sharedCustomViews,
            companyTools        : this.companyTools,
            collapsedDepartments: this.collapsedDepartments,
            collapsedSettings   : this.collapsedSettings,
            myReports           : this.myReports
        }

        this.configAllCompanies[gd.companyId] = result

        return this.configAllCompanies
    }
}
